import { createEffect, createStore } from 'effector/compat';
import { altair } from 'antares';

const currentChannelStore = createStore({
    channel: {
        onid: 0,
        tsid: 0,
        sid: 0,
    }
});

const getCurrentChannel = createEffect('get-current-channel');

getCurrentChannel.use(() => {
    if (altair.isHbbTV()) {
        const channel = altair.getCurrentChannel();
        const { onid, tsid, sid } = channel;
        return Promise.resolve({
            channel: {
                onid,
                sid,
                tsid
            }
        })
    } else {
        return Promise.resolve({
            channel: {
                tsid: 516,
                onid: 29,
                sid: 716
            }
        })
    }
})

currentChannelStore.on(getCurrentChannel.done, (prevState, res) => {
    const { result } = res;
    return {
        channel: result.channel
    }
});

export { currentChannelStore, getCurrentChannel }